/**
 * 必須環境変数を取得し、未設定の場合はエラーを投げる
 * セキュリティリスク防止のため、ハードコードされたフォールバック値は使用しない
 */
const getRequiredEnvVar = (name: string): string => {
  const value = process.env[name];
  if (!value) {
    throw new Error(`必須環境変数 ${name} が設定されていません。ビルド時に正しい環境変数が設定されていることを確認してください。`);
  }
  return value;
};

export const API_CONFIG = {
  baseURL: getRequiredEnvVar('REACT_APP_API_URL'),
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
} as const;

export const getApiUrl = (endpoint: string): string => {
  // Normalize the base URL and endpoint to prevent double slashes
  const baseURL = API_CONFIG.baseURL.replace(/\/+$/, ''); // Remove trailing slashes
  const normalizedEndpoint = endpoint.replace(/^\/+/, ''); // Remove leading slashes
  
  // Combine baseURL and endpoint with a single slash
  return `${baseURL}/${normalizedEndpoint}`;
};